export default __webpack_public_path__ + "assets/fonts/open-sans-v27-latin-500.eot";